import { render } from "./form-fileupload.vue?vue&type=template&id=6a36ddb8"
import script from "./form-fileupload.vue?vue&type=script&lang=js"
export * from "./form-fileupload.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__